import { render, staticRenderFns } from "./AdvancedOrderedSelect.vue?vue&type=template&id=54d5b044&"
import script from "./AdvancedOrderedSelect.vue?vue&type=script&lang=ts&"
export * from "./AdvancedOrderedSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports